<template>
  <div>
    <Button
      :link="
        store.ServerUrl +
        '/up/ae/' +
        store.serverConf[store.currentServer].androidfilename
      "
      :text="messages.downloadTerminal[store.langSelect.value]"
      acolor="#f7f7f7"
      style="margin-top: 30px"
    />
    <div style="margin-top: 40px;margin-left: 40px;">
      <qrcode-vue :value="store.ServerUrl +      '/up/ae/' +     store.serverConf[store.currentServer].androidfilename" size="150" levele="H" />
    </div>
    <div style="margin-top: 40px; margin-left: 0">
      <div
        style="width: 870px; margin-bottom: 40px;  position: relative"
        class="lk_content_info_block"
      >
        <div style="display: table-cell; width: 70px">
          <el-icon
            style="
              font-size: 50px;
              position: absolute;
              transform: rotate(180deg);
              left: 20px;
              color: #e82862;
            "
          >
            <Warning />
          </el-icon>
        </div>
        <div style="display: table-cell" class="lk_content_info_block_ul">
          <div v-if="store.langSelect.value === 0">
            Приложение АЕ это торговый терминал крипто деривативами в твоем
            Android смартфоне:
            <br />
            <br />
            <li>
              Доски опционов и конструктор опционных стратегий с широкими
              возможностями моделирования
            </li>

            <li>
              Торговые роботы (Дельта хеджер, сеточник Stairs и другие) и ручная
              торговля в стаканах котировок фьючерсами и опционами
            </li>

            <li>
              Графики опционных комбинаций на аккаунте АЕ и ценовые графики с
              ордерами и трейдами
            </li>

            Создавай опционные стратегии и торгуй в своем телефоне везде!
          </div>
          <div v-if="store.langSelect.value === 1">
            The AE application is a crypto derivatives trading terminal on your
            Android smartphone:
            <br />
            <br />
            <li>
              Option boards and an option strategy constructor with wide
              modeling capabilities
            </li>

            <li>
              Trading robots (Delta hedger, Stairs grid and others) and manual
              trading in quotes glasses for futures and options
            </li>

            <li>
              Option combination charts on the AE account and price charts with
              orders and trades
            </li>

            Create option strategies and trade on your phone everywhere!
          </div>
        </div>
      </div>
      <img :src="store.ServerUrl+'/images/android/photo_2024-09-15_01-04-50.jpg'" width="300px"/>
      <img :src="store.ServerUrl+'/images/android/photo_2024-09-15_01-05-00.jpg'" width="300px" style="margin-left: 5px;"/>
      <img :src="store.ServerUrl+'/images/android/photo_2024-09-15_01-05-11.jpg'" width="300px" style="margin-left: 5px;"/>
      <img :src="store.ServerUrl+'/images/android/photo_2024-09-15_01-05-18.jpg'" width="910px"/>
      <img :src="store.ServerUrl+'/images/android/photo_2024-09-15_01-05-22.jpg'" width="300px" style="margin-left: 155px;"/>
      <img :src="store.ServerUrl+'/images/android/photo_2024-09-15_01-05-28.jpg'" width="300px" style="margin-left: 5px;"/>

    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import { useMyStorage } from "@/store/global";
import Button from "@/components/Button";
import { Warning } from "@element-plus/icons-vue";
import QrcodeVue from "qrcode.vue";
export default defineComponent({
  name: "AndroidComponent",
  components: {
    Button,
    Warning,
    QrcodeVue
  },
  setup() {
    const store = useMyStorage();
    const messages = {
      downloadTerminal: ["Скачать android .apk", "Download android .apk"],
      androidinfo: [
        "Приложение АЕ это торговый терминал крипто деривативами в твоем Android смартфоне:<br/><br/>" +
          "<li> Доски опционов и конструктор опционных стратегий с широкими возможностями моделирования</li><br/><br/>" +
          "<li> Торговые роботы (Дельта хеджер, сеточник Stairs и другие) и ручная торговля в стаканах котировок фьючерсами и опционами</li><br/><br/>" +
          "<li> Графики опционных комбинаций на аккаунте АЕ и ценовые графики с ордерами и трейдами</li><br/><br/>" +
          "Создавай опционные стратегии и торгуй в своем телефоне везде!",
        "",
      ],
    };
    return { messages, store };
  },
});
</script>
<style scoped>
.lk_content_info_block {
  border: 1px solid #f8ebeb;
  border-radius: 10px;
  padding: 12px 20px;
  display: table;
  table-layout: fixed;
  position: relative;
}
.lk_content_info_block_ul {
  font-size: 18px;
}
.lk_content_info_block_ul li {
  list-style-image: url(http://127.0.0.1:8080/lk/img/arrow-right.7d3384dc.svg);
  font-size: 18px;
  margin-bottom: 15px;
}
</style>
